// Shared asset URLs
export const LOGO_FULL = "https://customer-assets.emergentagent.com/job_b808b2a7-42cd-4fbf-ba23-b9580d0dbae9/artifacts/eo86hacn_FULL.Top%20Screen%E2%84%A2.png";
export const LOGO_ANIMATED = "https://customer-assets.emergentagent.com/job_b808b2a7-42cd-4fbf-ba23-b9580d0dbae9/artifacts/bystgl51_Top%20Screen%E2%84%A2.gif";
// FAVICON — bundled locally in public/ so the footer logo ships with the build
// and never depends on an external CDN URL that may rotate/expire.
export const FAVICON = "/topscreen-logo.png";
export const LOGO_NAME_GREEN = "https://customer-assets.emergentagent.com/job_4748f6b5-3b8d-492f-91fd-748e95efd4dd/artifacts/uumrwev5_Top%20Screen%E2%84%A2%20logo.only.gif";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
